<template>
  <a :href="'/seminars/' + seminar.id" class="post">
    <div class="postHeader" :style="'background-image: url(' + thumbnail + ');background-position:top;background-color: #ffffff;'">
    </div>
    <div class="postFooter">
      <div class="postType">【{{ type }}】<span v-if="seminar.show_message">&lt;WEB配信&gt;</span></div>
      <div class="postTitle">{{ seminar.title }}</div>
      <div v-if="seminar.tags" class="postTag">
        <tags :tags="seminar.tags" type="seminars"></tags>
      </div>
    </div>
  </a>
</template>

<script>
  export default {
    props: [
      'seminar',
      'thumbnail',
      'alreadyReserved',
      'canBeReserved',
      'type',
    ]
  }
</script>

<style lang="scss" scoped>
  @import '../../sass/variables';

  // Medium ~
  @media (min-width:751px){
    .post{margin:0 10px 20px; color: $cText; background: white; cursor: pointer;
      &Header{position:relative;height:calc(((100vw - 60px) / 4 - 10px * 2) * 9 / 16);background-size: 100% auto;
          &::after{@include anime;content: ""; display: block; width: 100%; height: 100%; background: none;}
      }
      &Footer{padding:10px 20px 20px;}
      &Type, &Title{align-items: flex-start; overflow: hidden; max-height: 3em; margin-bottom: 5px; font-size: 16px;font-weight: bold;}
      &Tag{max-height:2rem;overflow:hidden;}
    }
  }
  // Small
  @media (max-width:750px){
    .post{padding: 10px 0; color: $cText; cursor: pointer;
      &Header{position:relative; width:35%; background-size: 100% auto; height: calc((100vw - 20px) * 0.35 * 0.6);background-position: center !important;background-color:#EFEFEF !important;
          &::after{@include anime;content: ""; display: block; width: 100%; height: 100%; background: none;}
      }
      &Footer{padding-left:20px; width:65%;}
      &Type, &Title{align-items: flex-start; overflow: hidden; max-height: 3.2em; font-weight: bold;}
      &Tag{display: none;}
    }
  }
  </style>
